import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedBookHero from "./sections/FeaturedBookHero";
import MaximizeYourHotelsRevparToday from "./sections/MaximizeYourHotelsRevparToday";
import Bookhero from "./sections/Bookhero";
import OurGlobalDestinations from "./sections/OurGlobalDestinations";
import ArtistCommunity from "./sections/ArtistCommunity";
import BookHero from "./sections/BookHero";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FeaturedBookHero />
      <MaximizeYourHotelsRevparToday />
      <Bookhero />
      <BookHero />
      <OurGlobalDestinations />
      <ArtistCommunity />
      <Footer />
    </div>;
}